var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('EntityList',{attrs:{"config":_vm.config,"custom-query":_vm.customQuery,"columns":_vm.columns,"filter-vals":_vm.filterVals,"filters":_vm.filters,"formatted-columns":_vm.formattedColumns,"allow-duplicate":false,"export-extra-columns":{
    extraColumns: _vm.extraColumns,
    key: 'fields',
    parent: 'field',
  },"extra-actions":_vm.extraActions,"has-insert-btn":_vm.id > 0,"authority":"Questionnaire_Management_Answer","single-edit":"","allow-edit-columns":"","desc-sort":""},on:{"filtersUpdated":_vm.filtersUpdated}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }